import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Dummy API (JSONPlaceholder)
export const apiSlice = createApi({
  reducerPath: 'api', // optional, defaults to 'api'
  baseQuery: fetchBaseQuery({ baseUrl: 'https://jsonplaceholder.typicode.com/' }),
  endpoints: (builder) => ({
    getPosts: builder.query({
      query: () => 'posts', // GET /posts
    }),
  }),
});

export const { useGetPostsQuery } = apiSlice;
